import policy from '../config/account-storage.json' with {type: 'json'};

/** account-storage.json sets the file allowance installed on the host. */
export const ACCOUNT_STORAGE_LABEL = `${policy.limitBytes / 1_000_000_000} GB`;
